import React, { useEffect, useState } from 'react';
import { BsFacebook, BsLinkedin, BsInstagram, BsGithub } from 'react-icons/bs';
import AOS from 'aos';
import 'aos/dist/aos.css';







const SocialMedia = () => {


    useEffect(() => {
        AOS.init({
            duration: 5000
        })
    }, [])










































































    let initialMarginTop = 200;
    const [scrollPosition, setScrollPosition] = useState(0);
    useEffect(() => {
        const handleScroll = () => {
            setScrollPosition(window.scrollY);
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    const marginTop = scrollPosition === 0 ? initialMarginTop : 200;
    const handleScroll = () => {
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;
        const scrollTop = window.scrollY;
        if (documentHeight - (scrollTop + windowHeight) < 20) {
            yourFunctionToBeCalled();
        }
    };
    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    const yourFunctionToBeCalled = () => {
        console.log('Near or at the bottom of the page.');
        initialMarginTop = 300;
    };














    return (


        // <div className='fixed z-50  md:ml-4 ml-1 lg:-ml-2 lg:top-[260px] md:top-[360px] sm:top-[90px] top-[90px] animation   md:right-auto right-2' data-aos='fade-right'>
        //     <div>
        //         <div className=' mx-auto'>
        //             <a href='https://github.com/Fahimsakib1?tab=repositories' target='blank' className='tooltip' data-tip='GitHub'>
        //                 <BsGithub className='md:text-3xl text-[27px] my-1 bg-black text-white rounded-lg transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsGithub>
        //             </a>
        //         </div>
        //         <div className='mx-auto'>
        //             <a href='https://www.linkedin.com/in/fahim-faysal/' target='blank' className='tooltip' data-tip='LinkedIn'>
        //                 <BsLinkedin className='md:text-3xl text-[27px] my-1 text-blue-700 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsLinkedin>
        //             </a>
        //         </div>
        //         <div className=' mx-auto'>
        //             <a href='https://www.instagram.com/i_fahiim/' target='blank' className='tooltip' data-tip='Instagram'>
        //                 <BsInstagram className='md:text-3xl text-[27px] my-1 text-rose-500 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsInstagram>
        //             </a>
        //         </div>
        //         <div className=' mx-auto'>
        //             <a href='https://www.facebook.com/fahim.sakib.5' target='blank' className='tooltip' data-tip='Facebook'>
        //                 <BsFacebook className='md:text-3xl text-[27px] my-1 text-blue-500 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsFacebook>
        //             </a>
        //         </div>
        //     </div>

        // </div>










        // <div>
        //     <div className={`fixed  top-6 left-4            z-50 md:right-auto right-2 lg:top-[250px] md:mt-[${marginTop}px]  sm:top-[250px] top-[110px]`} >

        //         <div className='    z-10 fixed animation   md:right-auto right-2' data-aos='fade-right'>
        //             <div>
        //                 <div className=' mx-auto'>
        //                     <a href='https://github.com/Fahimsakib1?tab=repositories' target='blank' className='tooltip' data-tip='GitHub'>
        //                         <BsGithub className='md:text-3xl text-[27px] my-1 bg-black text-white rounded-lg transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsGithub>
        //                     </a>
        //                 </div>
        //                 <div className='mx-auto'>
        //                     <a href='https://www.linkedin.com/in/fahim-faysal/' target='blank' className='tooltip' data-tip='LinkedIn'>
        //                         <BsLinkedin className='md:text-3xl text-[27px] my-1 text-blue-700 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsLinkedin>
        //                     </a>
        //                 </div>
        //                 <div className=' mx-auto'>
        //                     <a href='https://www.instagram.com/i_fahiim/' target='blank' className='tooltip' data-tip='Instagram'>
        //                         <BsInstagram className='md:text-3xl text-[27px] my-1 text-rose-500 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsInstagram>
        //                     </a>
        //                 </div>
        //                 <div className=' mx-auto'>
        //                     <a href='https://www.facebook.com/fahim.sakib.5' target='blank' className='tooltip' data-tip='Facebook'>
        //                         <BsFacebook className='md:text-3xl text-[27px] my-1 text-blue-500 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsFacebook>
        //                     </a>
        //                 </div>
        //             </div>
        //         </div>
        //     </div>

        // </div>














        <div className=''>
            <div className={`fixed  top-6 lg:left-4  md:left-10   z-50  right-2 lg:top-[250px] md:mt-[${marginTop}px]  sm:top-[250px] top-[110px] md:ml-[700px] lg:ml-0 ml-0    `} >
                <div className=' z-10 fixed animation   md:right-auto right-2' data-aos='fade-right'>
                    <div>
                        <div className=' mx-auto'>
                            <a href='https://www.facebook.com/fahim.sakib.5' target='blank' className='tooltip tooltip-right' data-tip='Facebook'>
                                <BsFacebook className='md:text-3xl text-[27px] my-1 text-blue-700 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsFacebook>
                            </a>
                        </div>
                        <div className=' mx-auto'>
                            <a href='https://github.com/Fahimsakib1?tab=repositories' target='blank' className='tooltip tooltip-right' data-tip='GitHub'>
                                <BsGithub className='md:text-3xl text-[27px] my-1 bg-black text-white rounded-lg transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsGithub>
                            </a>
                        </div>
                        <div className='mx-auto'>
                            <a href='https://www.linkedin.com/in/fahim-faysal/' target='blank' className='tooltip tooltip-right' data-tip='LinkedIn'>
                                <BsLinkedin className='md:text-3xl text-[27px] my-1 text-blue-800 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsLinkedin>
                            </a>
                        </div>
                        <div className=' mx-auto'>
                            <a href='https://www.instagram.com/i_fahiim/' target='blank' className='tooltip tooltip-right' data-tip='Instagram'>
                                <BsInstagram className='md:text-3xl text-[27px] my-1 text-rose-600 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsInstagram>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

        </div>



















    );
};

export default SocialMedia;